import * as React from 'react';

export const SummaryTab = () => {
  return <div>TBA tab content: SummaryTab</div>;
};
